// @flow strict
import * as React from 'react'
import { type PropsWithChildren, Button } from '@mondough/public-web-components'
import paidStyles from './PaidTextAndImage.module.scss'
import defaultStyles from '../TextAndImageSection.module.scss'
import sharedStyles from '../deviceVisibility.module.scss'
import PaidSectionWrapper from '../PaidSectionWrapper'
import PaidSubtitleSection from './PaidSubtitleSection'
import { MarkdownContent } from '../MarkdownContent'
import { type TextAndImageProps } from '../TextAndImageSection'

const PaidTextAndImage = ({
  title,
  description,
  imageUrls,
  imageAlts,
  reverse,
  children,
  cta,
  className,
}: PropsWithChildren<
  TextAndImageProps,
  React.Element<typeof PaidSubtitleSection>,
>) => (
  <PaidSectionWrapper
    className={className ? className : paidStyles.defaultSectionStyle}
    contentClassName={
      reverse ? paidStyles.reverseContent : paidStyles.forwardContent
    }
  >
    {children}
    <div className={paidStyles.textCol}>
      <div className={paidStyles.textContent}>
        {/*
         * Build the title as a <h3 /> when children exist.
         * This is because the child elements will be a <SubtitleSection />
         * which will build the <SubtitleSection /> with an <h2 />
         */
        children ? (
          <h3 className={paidStyles.title}>{title}</h3>
        ) : (
          <h2 className={paidStyles.title}>{title}</h2>
        )}
        <MarkdownContent className={paidStyles.description}>
          {description}
        </MarkdownContent>
        {cta && (
          <div className={defaultStyles.cta}>
            <Button href={cta.href}>{cta.text}</Button>
          </div>
        )}
      </div>
    </div>
    <div className={paidStyles.imgCol}>
      <img
        src={imageUrls && imageUrls.desktop}
        alt={imageAlts ? imageAlts.desktop : ''}
        className={sharedStyles.desktopOnly}
      />
      <img
        src={imageUrls && (imageUrls.mobile || imageUrls.desktop)}
        alt={imageAlts ? imageAlts.mobile || imageAlts.desktop : ''}
        className={sharedStyles.mobileOnly}
      />
    </div>
  </PaidSectionWrapper>
)

export default PaidTextAndImage
